import { Component } from 'react';
import { connect } from 'react-redux';

import { CheckoutLayout } from 'common/components/layout';
import { createClubSignup } from 'redux/clubSignup/actions';
import { getClubBySlug } from 'redux/clubs/reducers';

import Signup from './signup/Signup';
import SignupHostedPayment from './signupHostedPayment/Signup';

class SignupWrapper extends Component {
  componentDidMount() {
    const { props } = this;
    const { slug } = props.match.params;
    props.createClubSignup(slug);
  }

  render() {
    const { settings, club, clubSignup, match } = this.props;
    const { slug } = match.params;

    if (!settings.data || !club || !clubSignup.data) {
      return (
        <CheckoutLayout title="Club Signup" loading>
          &nbsp;
        </CheckoutLayout>
      );
    }
    const { payment } = settings.data;
    if (payment.gateway === 'PayGateHosted') {
      return <SignupHostedPayment slug={slug} />;
    }
    return <Signup slug={slug} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  const club = getClubBySlug(state.club, ownProps.match.params.slug);
  return {
    club,
    clubSignup: state.clubSignup,
    settings: state.setting
  };
};

export default connect(mapStateToProps, {
  createClubSignup
})(SignupWrapper);
